module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGUlEQVR4nGPwCnL+TwlmGDVg1IBRA4aLAQAk5t4QPCmrsAAAAABJRU5ErkJggg=="